<template>
    <div class="mybody" v-on:click="checkToggle">
        <div id="myframe" class="myframe">
            <div class="circle" v-bind:class="{'checked' : checked}"></div>
        </div>
        <label v-bind:class="{'checked' : checked}" for="myframe">{{label}}</label>
    </div>
</template>

<script>
    export default {
        name: "CheckSlider",
        data: function (){
            return {
                checked: false
            }
        },
        mounted: function(){
            this.checked = this.value
        },
        props:{
            label: String,
            value: Boolean
        },
        methods:{
            checkToggle: function () {
                this.checked = ! this.checked;
                this.$emit('input', this.checked)
            }
        }
    }
</script>

<style scoped>
    input{
        display: none;
    }

    .mybody{
        cursor: pointer;
        display: flex;
        color: #444;
        font-size: 0.9rem;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }

    .mybody label{
        text-shadow: none;
        color: #444444;
        font-weight: bold;
    }

    .mybody label.checked{
        color: #ff7a2c;
        text-shadow: 0px 1px 1px #444;
        font-weight: bold;
        transition: all 0.3s;
    }

    .myframe{
        display: inline-block;
        background-color: #EEEEEE;
        width: 2rem;
        height: 1rem;
        border-top: 2px solid #35324e;
        border-left: 1px solid #fff;
        border-bottom: 1px solid #fff;
        border-right: 1px solid #35324e;
        border-radius: 0.5rem;
    }

    .circle{
        position: relative;
        left: 0;
        border-radius: 50%;
        width: calc(1rem - 2px);
        height: calc(1rem - 2px);
        border-top: 1px solid #d2d2d2;
        border-left: 1px solid #6b6b6b;
        border-bottom: 1px solid #6b6b6b;
        border-right: 1px solid #d2d2d2;
        background-color: #9a9a9a;
        transition: all 0.3s;
    }

    .circle.checked{
        left: 1rem;
        transition: all 0.3s;
        border-top: 1px solid #ff994e;
        border-left: 1px solid #8d4725;
        border-bottom: 1px solid #8d4725;
        border-right: 1px solid #ff994e;
        background-color: #ff7a2c;
    }
</style>
